module.exports = __webpack_public_path__ + "static/media/NotoSansArabic-Regular.8808bcec.ttf";